<script lang="ts" setup name="UserListPendingUserInfo">
import { AVATAR_PENDING } from '~/constants';

import Avatar from '~/components/Avatar.vue';

const { email } = defineProps<{
  email?: string;
}>();
</script>

<template>
  <div class="flex items-center">
    <Avatar size="lg" :variant="AVATAR_PENDING" />
    <div class="space-y-1 truncate pl-4">
      <p
        class="max-w-max rounded-full bg-charcoal-1 px-3 text-body-2 uppercase text-charcoal-6"
      >
        Pending
      </p>
      <p v-if="email" class="truncate text-body-2 text-charcoal-6">
        {{ email }}
      </p>
    </div>
  </div>
</template>
